import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={25.702}
    height={25.485}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 24738 24529"
    {...props}
  >
    <path
      d="M1987 21106c0-262 79-342 342-342h20080c517 0 342 586 342 1826H1987v-1484zm8100-7872h4564c235 0 2144 1739 2425 2025l3964 3566H3698l5477-4906c216-166 645-685 912-685zm457-11294h3650v9355h-3650V1940zM47 20194c0 1234-338 4335 799 4335h23046c1137 0 799-3101 799-4335 0-1146-1078-1654-2027-2537l-967-858c-206-182-310-330-516-512l-3933-3482c-1147-1148-1116-265-1114-2537l3-9359c-45-590-438-909-1030-909H9631c-543 0-956 303-1022 804l-5 9236c0 488 108 1352-56 1770-99 252-2487 2253-2938 2652L663 18870c-395 301-616 680-616 1324z"
      style={{
        fill: "#000",
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
